import React, { useEffect, useRef, useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../../../context/AuthContext";

import "./Header.css";

export default function Header({ onOpenCart, mobileMenuOpen, onToggleMobile }) {
  const [hidden, setHidden] = useState(false);
  const lastScrollY = useRef(0);
  const navigate = useNavigate();

  // 1. Pegamos os dados do usuário e a função de logout do Contexto
  const { userData } = useAuth();

  const handleNavAction = () => {
    if (mobileMenuOpen && typeof onToggleMobile === "function") {
      onToggleMobile();
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      const currentScroll = window.scrollY;
      const delta = currentScroll - lastScrollY.current;

      if (currentScroll < 10) {
        setHidden(false);
      } else if (delta > 10) {
        setHidden(true);
      } else if (delta < -10) {
        setHidden(false);
      }

      lastScrollY.current = currentScroll;
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Função para lidar com o logout e redirecionar

  return (
    <header className={`cabecalho${hidden ? " escondido" : ""}`} id="cabecalho">
      <div className="cabecalho-inner">
        <Link to="/" className="logo-repique" onClick={handleNavAction}>
          <div className="nomes">
            <span className="logo-texto">Repique</span>
            <span className="logo-subtitulo">Esporas</span>
          </div>
        </Link>

        <nav
          className={`nav-categorias ${mobileMenuOpen ? "aberto" : ""}`}
          id="navCategorias"
        >
          <NavLink
            to="/"
            className={({ isActive }) => `nav-link ${isActive ? "ativo" : ""}`}
            onClick={handleNavAction}
          >
            Início
          </NavLink>
          <NavLink
            to="/produtos"
            className={({ isActive }) => `nav-link ${isActive ? "ativo" : ""}`}
            onClick={handleNavAction}
          >
            Produtos
          </NavLink>
          <NavLink
            to="/sua-espora"
            className={({ isActive }) => `nav-link ${isActive ? "ativo" : ""}`}
            onClick={handleNavAction}
          >
            Monte sua Espora
          </NavLink>
          <NavLink
            to="/contato"
            className={({ isActive }) => `nav-link ${isActive ? "ativo" : ""}`}
            onClick={handleNavAction}
          >
            Contato
          </NavLink>

          {userData?.role === "admin" && (
            <button
              className="btn-admin-mobile"
              type="button"
              onClick={() => {
                handleNavAction();
                navigate("/dashboard");
              }}
            >
              ADMIN
            </button>
          )}
        </nav>

        <div className="cabecalho-acoes">
          {/* 2. Lógica condicional: Botão de Perfil ou Login - Desktop */}
          {userData ? (
            <Link to={"/meu-perfil"} style={{ textDecoration: "none" }}>
              <button className="btn-perfil" aria-label="Perfil">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.5"
                >
                  <circle cx="12" cy="8" r="4" />
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                </svg>
                <span className="btn-texto">Perfil</span>
              </button>
            </Link>
          ) : (
            <button
              type="button"
              className="btn-admin-desktop"
              onClick={() => navigate("/login")}
              aria-label="Login"
              style={{
                marginRight: "8px",
                padding: "8px 15px",
                border: "1px solid rgba(255,255,255,0.1)",
                borderRadius: "4px",
                background: "transparent",
                color: "white",
                cursor: "pointer",
                fontSize: "12px",
                textTransform: "uppercase",
              }}
            >
              LOGIN
            </button>
          )}

          {/* Botão de Login Mobile - Aparece ao lado do carrinho em mobile */}
          {!userData && (
            <button
              type="button"
              className="btn-login-mobile"
              onClick={() => navigate("/login")}
              aria-label="Login"
            >
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
              >
                <circle cx="12" cy="8" r="4" />
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
              </svg>
              <span className="btn-texto">Login</span>
            </button>
          )}

          <button className="btn-carrinho" type="button" onClick={onOpenCart}>
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.5"
            >
              <path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z" />
              <line x1="3" y1="6" x2="21" y2="6" />
              <path d="M16 10a4 4 0 01-8 0" />
            </svg>
            <span className="btn-texto">Carrinho</span>
          </button>

          {/* 3. Botão Sair (só aparece se estiver logado) - removido do header, agora no menu mobile */}

          {userData && userData.role === "admin" && (
            <button
              className="btn-admin-desktop"
              onClick={() => navigate("/dashboard")}
            >
              ADMIN
            </button>
          )}

          <button
            className="menu-hamburger"
            type="button"
            onClick={onToggleMobile}
          >
            <span />
            <span />
            <span />
          </button>
        </div>
      </div>
    </header>
  );
}
